import React from "react";

export default function DataRetention() {
  return (
    <div>
      <div className="tp-award-area pb-125">
        <div className="container container-1630">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-service-5-title-box text-center">
                <h3 className="tp-hero-3-title tp_reveal_anim ">
                  Data Retention & User Rights
                </h3>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12">
              <div className="tp-award-list-wrap">
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-2"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <p>Access Your Data</p>
                    <span> Users can request a summary of collected data.</span>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-3"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <p>Request Data Deletion</p>
                    <span>
                      Non-blockchain-related personal data can be deleted upon
                      request (except transactional records on the blockchain).
                    </span>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <p>Opt-out of Communications</p>
                    <span>
                      Users can unsubscribe from non-essential emails.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
